/**
 * Return list of supported tracking params
 * @returns {Array} list of supported tracking params
 */
export default function getSupportedTrackingParams() {
	return ['src', 'sub_id', 'sub2_id', 'pub_id', 'account', 'campaign', 'ad_group', 'keyword', 'campaignid', 'adgroupid', 'agid', 'keywordid', 'loc1', 'loc2', 'kw', 'gclid', 'utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'program', 'motivation'];
}
